import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
// import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import axios from "axios";
import { Button, message, Input, Form } from "antd/lib";
import { useDispatch, useSelector } from "react-redux";
// import { Navbar } from "../Navbar/Navbar";
// import { ONBDetils } from "../../Redux/actions/OnboardAction";
import "./onboard.css";

function ChangePassWord({ setOpen }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  //const RemPass = useSelector((state) => state?.pass);
  const OTPData = useSelector((state) => state?.posp?.onboardOtp);
  const OnbNum = useSelector((state) => state?.posp?.Posp);
  const OnbDetails = useSelector((state) => state?.posp?.onbDetails);
  // const [OpenToLogin, setOpenToLogin] = useState(false);
  const [loading, setloading] = useState(false);
  //   const [rememberPassword, setRememberPassword] = useState(false);
  const [BaseUrl, setBaseURL] = useState("");

  // console.log(OTPData)

  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
  }, [BaseUrl]);

  const validatePassword = (_, value) => {
    const uppercaseRegex = /[A-Z]/;
    const numberRegex = /\d/;
    // const specialCharRegex = /[^A-Za-z0-9]/;
    const minLengthRegex = /.{8,}/;
    const errors = [];
    console.log(errors);
    if (value) {
      if (!uppercaseRegex.test(value)) {
        errors.push("one Uppercase");
      }
      if (!numberRegex.test(value)) {
        errors.push("one number");
      }
      //   if (!specialCharRegex.test(value)) {
      //     errors.push('one special character');
      //   }
      if (!minLengthRegex.test(value)) {
        errors.push("at least 8 characters long");
      }
    }
    if (errors.length === 0) {
      return Promise.resolve();
    }
    return Promise.reject(`Password must contain ${errors.join(", ")}`);
  };

  const handleSubmit = (values) => {
    console.log(values);
    const token = OnbNum?.accessToken;

    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
    let post = {
      current_password: values?.old_password,
      new_password: values?.new_password,
      new_password_confirmation: values?.cnfrm_password,
    };
    setloading(true);
    axios
      .post(`${BaseUrl}v1/posp/change_password`, post, { headers })
      .then((res) => {
        console.log(res);
        const Udata = res?.data;
        console.log(Udata);
        message.success(Udata?.message + "Login Again");
        setloading(false);
        dispatch((dispatch) => {
          dispatch({ type: "LOGOUT_POSP" });
          // dispatch({ type: "LOG_STATE" });
        });
        setTimeout(() => {
          setOpen(false);
        }, 300);
        // history.push("/");
        // setOpenToLogin(true);

        // dispatch((dispatch) => {
        //   dispatch({ type: "LOGOUT_POSP" });
        // });
        // history.push("/");
      })
      .catch((err) => {
        console.log(err.response);
        if (err.response.data.message === "Unauthenticated.") {
          dispatch({ type: "LOGOUT_POSP" });
          history.push("/");
        }
        setloading(false);
        message.error(err?.response?.data?.message);
      });
  };

  return (
    <>
      {/* <UatNav/> */}
      <div className="container justify-content-center h-100 align-items-center row bg-white">
        <div className="col-xl-7 col-lg-7 col-md-6">
          <div className="login-container-Cp">
            <div className="d-block text-center my-2"></div>
            <Form
              onFinish={handleSubmit}
              form={form}
              //requiredMark={false}
              layout="vertical"
            >
              <Form.Item
                label="Old Password"
                name="old_password"
                rules={[
                  {
                    required: true,
                    message: "Enter Old Password",
                  },
                ]}
              >
                <Input.Password
                  style={{ width: "100%" }}
                  placeholder="Enter Old Password"
                />
              </Form.Item>
              <Form.Item
                label="New Password"
                name="new_password"
                rules={[
                  {
                    required: true,
                    message: "Enter new password",
                  },
                  {
                    validator: validatePassword,
                  },
                ]}
              >
                <Input.Password placeholder="Confirm New Password" />
              </Form.Item>
              <Form.Item
                label="Confirm New Password"
                name="cnfrm_password"
                rules={[
                  {
                    required: true,
                    message: "please Confirm New Password",
                  },
                ]}
              >
                <Input.Password placeholder="Confirm New Password" />
              </Form.Item>
              <Form.Item className="mb-2">
                <Button type="primary" htmlType="submit" loading={loading}>
                  Change Password
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export { ChangePassWord };
